module.exports = __webpack_public_path__ + "static/09_KP-ef8d2d520ca2be6f12d46762e40cd43e.png";